import { extractCountryCode } from "./utils";
import { setTag } from "./tagMapper";
import { setDistrictData } from "./districtMapper";
import { setCampusData } from "./campusMapper";
import { isValidValue, logger } from "utils";
// const defaultCampus = {
//   CreatedAt: "2025-10-28T16:33:22.515457055Z",
//   UpdatedAt: "2025-10-28T16:33:22.515457055Z",
//   DeletedAt: null,
//   ID: "ccad2252-4662-4d7a-8324-0a122eae7877",
//   campus_number: 1505,
//   district_id: "d1a0aaad-e9a0-4335-975c-a5076c15170a",
//   name: "Testin",
//   address: "Testing",
//   city: "ss",
//   state: "DE",
//   zip_code: "123456",
//   invite_code: "TES734",
//   pocs: [
//     {
//       email: "nishant.garg@mithrildefense.com",
//       first_name: "Nishant",
//       last_name: "Garg",
//       phone_number: "+11111111111",
//       prefix: "mr",
//       title: "principal",
//       type: "principal",
//     },
//     {
//       email: "nishant.garg@mithrildefense.com",
//       first_name: "Nishant",
//       last_name: "Garg",
//       phone_number: "+11111111111",
//       prefix: "mr",
//       title: "onSiteSecurity",
//       type: "onSiteSecurity",
//     },
//   ],
//   latitude: "1111",
//   longitude: "1111",
//   building_count: 0,
//   is_incident_in_progress: false,
// };
export const setCurrentUserData = (el = {}) => {
  try {
    const tags = (Array.isArray(el.tags) ? el.tags : []).map((e) => setTag(e));
    const districts = (Array.isArray(el.districts) ? el.districts : []).map(
      (e) => setDistrictData(e),
    );

    let building = [];
    const campuses = (
      Array.isArray(el.campuses) && el.campuses.length ? el.campuses : []
    ).map((campus) => {
      const campusData = setCampusData(campus);
      if (campusData.buildings.length) {
        campusData.buildings.forEach((e) => building.push(e));
      }
      return campusData;
    });

    const tempData = {
      districts,
      campuses,
    };
    let pendingScreen = null;
    if (!el.is_onboarding_complete) {
      ["campuses", "districts"].forEach((el1) => {
        if (tempData[el1].length) {
          if (el1 === "districts") {
            if (pendingScreen === "campuses" && !tempData[el1][0].idp_detail) {
              if (!tempData[el1][0].is_admin_invite_skipped) {
                pendingScreen = "invite_admin";
              } else if (!tempData[el1][0].is_auth_provider_skipped) {
                pendingScreen = "saml_auth";
              }
            }
          // } else if (el1 === "campuses") {
          //   const buildingsCount = tempData[el1].filter(
          //     (el2) => isValidValue(el2.buildings) && el2.buildings.length,
          //   ).length;
          //   if (!buildingsCount) {
          //     pendingScreen = "building";
          //   }
          }
        } else {
          pendingScreen = el1;
        }
      });
    }

    const { number, countryCode } = extractCountryCode(
      el.phone ?? el.phone_number,
    );
    return {
      id: el.ID || null,
      first_name: el.first_name || null,
      last_name: el.last_name || null,
      name: `${((el.first_name || "") + " " + (el.last_name || "")).trim()}`,
      email: el.email || null,
      phone_number: number,
      countryCode: countryCode,
      phone: el.phone ?? el.phone_number,
      title: el.title || null,
      type: el.type || "Internal",
      auth_provider: el.auth_provider || null,
      auth_provider_id: el.auth_provider_id || null,
      is_location_enabled: el.is_location_enabled || false,
      is_camera_enabled: el.is_camera_enabled || false,
      is_microphone_enabled: el.is_microphone_enabled || false,
      is_notification_enabled: el.is_notification_enabled || false,
      note: el.note || null,
      date_of_birth: el.date_of_birth || null,
      profile_pic: el.profile_pic || null,
      // is_onboarding_complete: false,
      is_onboarding_complete: el.is_onboarding_complete || false,
      // is_onboarding_complete: true,
      districts,
      campuses,
      building,
      tags,
      role: el.role || null,
      role_id: el.role_id || null,
      district_id: el.district_id || null,
      primary_district_id: el.primary_district_id || null,
      role_name: el.role_name || "",
      notes: el.note || "",
      admin_panel_access: el.admin_panel_access || false,
      toc_desktop_app_access: el.toc_desktop_app_access || false,
      end_user_mobile_app_access: el.end_user_mobile_app_access || false,
      district_setup_access: el.district_setup_access || false,
      inviteStatus: isValidValue(el.first_name) ? "active" : "never_onboarded",
      pendingScreen: pendingScreen ?? null,
    };
  } catch (error) {
    logger.error("Error in setUserData:", error, el);
    throw error;
  }
};
